import React, { useState } from 'react';
import { Box, Typography, Link, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';

const NotificationBox = ({ type, title, description, onClose }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const getIcon = () => {
        switch (type) {
          case 'error':
            return <ErrorIcon color="error" sx={{ marginRight: '8px' }} />;
          case 'success':
            return <CheckCircleIcon color="success" sx={{ marginRight: '8px' }} />;
          case 'info':
            return <InfoIcon color="info" sx={{ marginRight: '8px' }} />;
          default:
            return null;
        }
      };

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                maxWidth: '100%',
                padding: '1%',
                border: '1px solid #ccc',
                backgroundColor: '#fff',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                marginBottom: '2%',
                wordWrap: 'break-word',
                whiteSpace: 'pre-wrap',
            }}
        >

            <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                {getIcon()}
                <Typography variant="h5" style={{ flexGrow: 1,marginTop: '3%'}}>
                    {title}
                </Typography>
                <IconButton size="small" onClick={onClose}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>

          { description?.length > 0 && <Box sx={{backgroundColor: '#f0f0f0',p: 1, m: 1,}} onClick={toggleExpand}>
                <Typography variant="body2">
                    {isExpanded ? description : `${description.substring(0, 50)}...`}
                    {description?.length > 50 && <div
                        component="button"
                        variant="body2"
                        style={{ padding: 0, cursor: 'pointer', color: '#1E90FF' }}
                    >
                        {isExpanded ? 'View Less' : 'View More'}
                    </div>}
                </Typography>
            </Box>}

        </Box>
    );
};

export default NotificationBox;
